import React from "react";
import { newIcon } from "../Icon";

export const DownArrow = newIcon(
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4L3.39896 4.60104C3.7309 4.93299 4.2691 4.93299 4.60104 4.60104L4 4ZM7.60104 1.60104C7.93299 1.2691 7.93299 0.730905 7.60104 0.398959C7.2691 0.0670136 6.7309 0.0670135 6.39896 0.398959L7.60104 1.60104ZM1.60104 0.398959C1.26909 0.0670133 0.730905 0.0670133 0.398959 0.398959C0.0670138 0.730905 0.0670137 1.26909 0.398959 1.60104L1.60104 0.398959ZM4.60104 4.60104L7.60104 1.60104L6.39896 0.398959L3.39896 3.39896L4.60104 4.60104ZM4.60104 3.39896L1.60104 0.398959L0.398959 1.60104L3.39896 4.60104L4.60104 3.39896Z"
      fill="#12171F"
    />
  </svg>,
  true
);
